import pricesActions from "./pricesActions";

export default pricesActions;
